export const appConfig = {
  mock: {
    useMockAuth: process.env.NODE_ENV === 'development',
    user: {
      alias: 'testuser',
    },
  },
} as const;
